import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormContext } from "react-hook-form";
import { ReportsCampaignSubTypeChoices } from "utils/choices";

const CandidateInfoLog = ({ handleParamChange }) => {
  const [campaignSubTypeId, setCampaignSubTypeId] = React.useState(null);
  const { setValue } = useFormContext();

  const handleSubTypeChange = e => {
    setCampaignSubTypeId(e.target.value);
    setValue("campaignId", null);
    handleParamChange("campaignId", null);
  };

  return (
    <>
      <SelectInput
        validate={required()}
        source="campaignSubTypeId"
        label="Тип Кампания"
        choices={ReportsCampaignSubTypeChoices}
        onChange={handleSubTypeChange}
      />
      {campaignSubTypeId && (
        <ReferenceInput
          label="Кампания"
          source="campaignId"
          reference={candidateRequests.getCampaignsSelect()}
          filter={{ subType: campaignSubTypeId }}
        >
          <SelectInput
            validate={required()}
            label="Кампания"
            disabled={!campaignSubTypeId}
            optionText="nameBg"
            onChange={e => handleParamChange("campaignId", e.target.value)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default CandidateInfoLog;
